import ReactGA from "react-ga4";

const isProduction = process.env.REACT_APP_ENV === 'production';

/**
 * Initialize Google Analytics 4
 */
export const initGA = () => {
    if (!isProduction) {
        console.log("[GA4] Initialization skipped (Environment:", process.env.REACT_APP_ENV, ")");
        return;
    }

    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (measurementId) {
        ReactGA.initialize(measurementId);
        console.log("GA4 Initialized with ID:", measurementId);
    } else {
        console.warn("GA4 Measurement ID not found. Please set REACT_APP_GA_MEASUREMENT_ID in .env");
    }
};

/**
 * Track Page View
 * @param {string} path 
 */
export const trackPageView = (path) => {
    if (isProduction) {
        ReactGA.send({ hitType: "pageview", page: path });
    } else {
        console.log(`[GA4] PageView: ${path}`);
    }
};

/**
 * Track Custom Event
 * @param {string} action 
 * @param {object} params 
 */
export const trackEvent = (action, params = {}) => {
    if (isProduction) {
        ReactGA.event(action, params);
    } else {
        console.log(`[GA4] Event: ${action}`, params);
    }
};

/**
 * Specific Funnel Events
 */
export const trackFunnelEvent = {
    // Login & Register
    loginStarted: (method) => trackEvent('login_started', { method }),
    loginSuccess: (method) => trackEvent('login_success', { method }),
    registerStarted: () => trackEvent('register_started'),
    registerSuccess: () => trackEvent('register_success'),

    // Navigation & Hall
    enterHall: () => trackEvent('enter_hall'),
    hallTutorialClose: (step) => trackEvent('hall_tutorial_close', { step }),

    // Interactions
    npcInteract: (npcName) => trackEvent('npc_interact', { character_name: npcName }),
    posterShowcaseOpen: (academicGroup) => trackEvent('poster_showcase_open', { academic_group: academicGroup }),
    thesisView: (thesisTitle, thesisId) => trackEvent('thesis_view', { thesis_title: thesisTitle, thesis_id: thesisId }),
    thesisDownload: (thesisTitle, thesisId) => trackEvent('thesis_download', { thesis_title: thesisTitle, thesis_id: thesisId }),

    // External Links
    externalLinkClick: (label, url) => trackEvent('external_link_click', { link_label: label, link_url: url }),

    // Search & Filter
    searchThesis: (keyword) => trackEvent('search_thesis', { search_term: keyword }),
    filterFaculty: (facultyName) => trackEvent('filter_faculty', { faculty_name: facultyName }),
};
